module.exports = __webpack_public_path__ + "static/media/mail.26680c50.svg";